// extracted by mini-css-extract-plugin
export default {"container":"ChatBox_container__gVFWd","rightSidebar":"ChatBox_rightSidebar__I8rwn","myChats":"ChatBox_myChats__OR7sO","singleChat":"ChatBox_singleChat__isLYf"};